import { configureStore } from "@reduxjs/toolkit";
import { compose } from "redux";
import persistState from "redux-localstorage";
import customerReducer from "./customer";
import authReducer from "./auth";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";

/**
 * @typedef CyberpassStore
 * @property {import('./auth.js').AuthSlice} auth
 * @property {import('./customer.js').CustomerSlice} customer
 */

const enhancer = compose(
  persistState(undefined, {
    key: "userCache",
    slicer: () => {
      console.debug("Persisting state");
      /**
       * @param {CyberpassStore} state
       * @returns {object}
       */
      return (state) => ({
        customer: {
          current: state.customer.current,
          recent: state.customer.recent,
          eventSourceId: state.customer.eventSourceId,
        },
        auth: {
          location: state.auth.location,
          accessToken: state.auth.accessToken,
          user: state.auth.user,
        },
      });
    },
  }),
);

/** @type {import('@reduxjs/toolkit').Store<CyberpassStore>} */
const store = configureStore({
  reducer: {
    customer: customerReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      createStateSyncMiddleware({
        broadcastChannelOption: { type: "localstorage" },
        /**
         * @param {{type: string}} action
         * @returns {boolean}
         */
        predicate: (action) => {
          return action.type === "customer/setOnlineOrder";
        },
        serialize: (state) =>
          JSON.stringify(state, (key, value) =>
            value === null ? "__NULL__" : value,
          ),
        deserialize: (state) =>
          JSON.parse(state, (key, value) =>
            value === "__NULL__" ? null : value,
          ),
      }),
    ),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat([enhancer]),
});

initMessageListener(store);
export default store;
